import { Badge } from "react-bootstrap";
import { STATUS_BADGE } from "../../BcaAttendance/components/StudentSession";

const columns = [
    {
        Header: "S.no",
        id: "s_no",
        width: "75",
    },
    {
        Header: "Status",
        width: "150",
        Cell: ({ row }) => {
            const bca = row.original.student_training_dates?.[0]?.student_bca;
            const status = bca?.[0]?.status;
            const label =
                bca === undefined
                    ? "NOT ASSIGNED"
                    : bca?.length === 0
                    ? "PENDING"
                    : status;
            return (
                <Badge
                    className={`border rounded-3 px-3 py-2 ${
                        STATUS_BADGE[label] || STATUS_BADGE.DEFAULT
                    }`}
                >
                    <span className="fw-bold">{label}</span>
                </Badge>
            );
        },
    },
    {
        Header: "Student Name",
        accessor: "enrolment.name",
        width: "300",
    },
    {
        Header: "Sponsor Company",
        accessor: "enrolment.sponsor_company.name",
        width: "325",
    },
    {
        Header: "Fin No",
        accessor: "enrolment.fin",
        width: "150",
    },
    {
        Header: "Trade",
        accessor: "enrolment.type_of_trade",
        width: "200",
    },
    {
        Header: "Application Opt",
        accessor: "enrolment.application_option",
        width: "200",
    },
    {
        Header: "Person-in-charge",
        accessor: "enrolment.invoice.sales_user.name",
        width: "200",
    },
];

export { columns };
